import Link from 'next/link';
import { useRef, useState } from 'react';
import { IProductObject } from '@features/categories/typescript';
import styles from '@components/ProductCardNew/ProductCard.styles';
import getProductUrl from '@utils/getProductUrl';
import ProductImage from '@components/ProductCardNew/ProductImage/ProductImage';
import Promolabels from '@components/ProductCardNew/PromoLabels/PromoLabels';
import ProductCardDescription from '@components/ProductCardNew/ProductCardDescription/ProductCardDescription';
import { useOffer } from '@hooks/useOffer';
import 'react-loading-skeleton/dist/skeleton.css';
type PropsType = {
  product: IProductObject;
  selectFunction?: () => void;
  fromModal?: boolean;
  isSmall?: boolean;
  transparent?: boolean;
  searchUrl?: string;
  searchHightlight?: JSX.Element;
  onAuxClick?: (e: React.MouseEvent) => void;
  isSlider?: boolean;
};
const ProductCard = ({
  product,
  selectFunction = () => null,
  fromModal = false,
  isSmall = false,
  transparent = false,
  isSlider = false,
  searchUrl = '',
  searchHightlight = undefined,
  onAuxClick = () => null
}: PropsType) => {
  const {
    id,
    name,
    uuid,
    packshots,
    configurable,
    getPromoPercent,
    getPrice,
    getOmnibusPrice,
    getPromoPrice,
    checkFlagActive,
    getFromFlag,
    swatches,
    colorsCount,
    priceUnit,
    gpsr
  } = product;
  const [isLoading, setIsLoading] = useState(true);
  const hoverRef = useRef<HTMLAnchorElement>(null);
  const [_, priceListName] = useOffer();
  const buildUrl = () => {
    if (searchUrl) return searchUrl;
    const base = getProductUrl(name, id);
    if (uuid !== undefined) {
      return `${base}?objectUuid=${uuid}`;
    }
    return base;
  };
  return <Link href={buildUrl()} ref={hoverRef} data-testid="ListingProductCard" sx={styles.productCard} onClick={() => selectFunction ? selectFunction() : null} aria-label={name} className={fromModal ? 'product_from_photo' : ''} onAuxClick={onAuxClick}>
      <div sx={styles.visualArea(transparent)}>
        <ProductImage packshots={packshots} alt={name || ''} setIsLoading={setIsLoading} isSmall={isSmall} isSlider={isSlider} />
        <Promolabels configurable={configurable} pricePromoPercent={getPromoPercent(priceListName)} checkFlagActive={checkFlagActive} hoverRef={hoverRef} isSmall={isSmall} transparent={transparent} />
      </div>
      <ProductCardDescription name={name} searchHightlight={searchHightlight} price={getPrice(priceListName)} priceUnit={priceUnit} promoPrice={getPromoPrice(priceListName)} omnibusPrice={getOmnibusPrice(priceListName)} showFrom={getFromFlag(priceListName)} swatches={swatches} totalColorsCount={colorsCount} isSmall={isSmall} isLoading={isLoading} gpsr={gpsr} />
    </Link>;
};
export default ProductCard;